import React from 'react'
import ContentHome from './content'
import Container from '../../components/container'
import '../../assets/styles/scss/pages/_home.scss'
import HeaderHome from '../../components/header'
import FooterHome from '../../components/footer'
import { HomeContextProvider } from './context/homeContext'

const Home = () => {
    return (
        <Container>
            <HomeContextProvider>
                <header className='div-header'>
                    <HeaderHome />
                </header>
                <div className="home-layout">
                    <div className="site-layout-content" >
                        <ContentHome />
                    </div>
                </div>
                <footer>
                    <FooterHome />
                </footer>
            </HomeContextProvider>
        </Container>
    )
}

export default Home